import React from 'react';
import SponsorsForm from './SponsorsForm';

const EditSponsorPage = () => {
    // This component will implicitly get the 'id' from the URL via the form's useParams hook.
    return <SponsorsForm formType="edit" />;
};

export default EditSponsorPage;
